export default "__VITE_ASSET__CRS$_Nte__"